import { expandableListItemFactory } from '@optimus-web/core';
import BillListItem from './BillListItem';

export default expandableListItemFactory({
    ListItem: BillListItem,
});
